<div class="tag" [class.optionalBorder]="optionalBorder" [class.michelin]="isMichelin" [class.new]="isNew">
	<ng-content></ng-content>
</div>
